import React from 'react';

class CaracteristicasEspecificacionesYAlcancesDePaquetesDeInternetFibraOptica_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Características, Especificaciones y Alcances de Paquetes de Internet Fibra Óptica';	
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_CARACTERISTICAS_ESPECIFICACIONES_ALCANCE_PAQUETES_INTERNET_FO_2024_V1.pdf?alt=media&token=682fecc7-4621-47cb-8f64-85130f1d978f';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default CaracteristicasEspecificacionesYAlcancesDePaquetesDeInternetFibraOptica_pdf